// eslint-disable-next-line import/prefer-default-export
export const origenes = {
  fallasBt: { urlApi: 'fallas-bt', urlBucket: 'fallas-bt' },
  migracion: { urlApi: 'levantamiento-inicial', urlBucket: 'levantamiento-inicial' },
  luminarias: { urlApi: 'luminarias', urlBucket: 'luminarias' },
  nemas: { urlApi: 'nemas', urlBucket: 'nemas' },
  ticketsCorrectivos: { urlApi: 'tickets', urlBucket: 'tickets' },
  entregaLuminarias: { urlApi: 'entrega-luminarias', urlBucket: 'entrega-luminarias' },
  migraciones: { urlApi: 'migracion-luminarias', urlBucket: 'migracion-luminarias' },
}
